import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { ProductsService } from '@app/services/products/product.service';

/**
 * Modal where the user types a UPC/EAN barcode and looks it up. On a hit it
 * reports "found" (without exposing which source answered) and lets the user
 * continue to the Add Product form pre-filled with the resolved data.
 */
@Component({
  selector: 'app-barcode-lookup-dialog',
  templateUrl: './barcode-lookup-dialog.component.html',
  styleUrls: ['./barcode-lookup-dialog.component.scss']
})
export class BarcodeLookupDialogComponent {
  public upc = '';
  public loading = false;
  public searched = false;
  public result: any = null;

  constructor(
    private dialogRef: MatDialogRef<BarcodeLookupDialogComponent>,
    private _products: ProductsService
  ) {}

  search(): void {
    const code = (this.upc || '').trim();
    if (code === '' || this.loading) {
      return;
    }
    this.loading = true;
    this.searched = false;
    this.result = null;
    this._products.lookupBarcode(code).pipe(first()).subscribe({
      next: (res) => {
        this.loading = false;
        this.searched = true;
        this.result = res;
      },
      error: () => {
        this.loading = false;
        this.searched = true;
        this.result = { found: false };
      }
    });
  }

  // Return the resolved data so the Add Product form can be pre-filled.
  use(): void {
    this.dialogRef.close({
      prefill: this.result?.data || null,
      barcode: (this.upc || '').trim()
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
